import { Validators } from '@angular/forms';
import { FormSchema } from './form-schema';

export const LOGIN_FORM_DEFAULT_SCHEMA: FormSchema = {
  username: {
    type: 'text',
    validators: [Validators.required],
    label: 'Username',
    icon: 'person'
  },
  password: {
    type: 'password',
    validators: [Validators.required],
    label: 'Password',
    icon: 'lock'
  }
};
